import { createContext, useContext, useState } from "react";

const AppConfigContext = createContext();

export const AppConfigProvider = ({ children }) => {
    const [appConfig, setAppConfig] = useState(null);

    return (
        <AppConfigContext.Provider value={{ appConfig, setAppConfig }}>
            {children}
        </AppConfigContext.Provider>
    );
};

export const useAppConfig = () => useContext(AppConfigContext);
